module.exports = __webpack_public_path__ + "img/mob_product_03.7fba801f.png";